
export default {
    pageTitle:{
      text:"Withdraw Application"
    },
    pageInfo:{
      text:"Please use the box below to enter a case note documenting your withdrawal request. Please note that submitting a withdrawal request will change the status of your application to Withdrawn. An application in Withdrawn status cannot be reinstated for further processing.",
      coloring: 'grey',
    },
    sections: [{
      fields: [
          {
              machine_name: 'case_note',
              widget: 'text_area',
              label: 'Case Note',
              validate: ['required'],
              inputLimit: 4000,
              rows: 7
          }
      ]
  
  }]}